var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44364 7.81839C7.08077 5.4193 10.8397 3.83767 12.7206 3.0735C18.0907 0.891658 19.2065 0.512649 19.9338 0.500133C20.0938 0.497381 20.4514 0.536106 20.6831 0.719742C20.8787 0.874801 20.9326 1.08426 20.9583 1.23128C20.9841 1.37829 21.0162 1.71319 20.9907 1.97487C20.6997 4.96165 19.4405 12.2098 18.7999 15.555C18.5288 16.9705 17.9951 17.4451 17.4784 17.4916C16.3554 17.5925 15.5027 16.7667 14.4151 16.0702C12.7132 14.9805 11.7517 14.3021 10.0997 13.2387C8.19056 12.0097 9.42819 11.3343 10.5162 10.2304C10.801 9.94148 15.7486 5.54547 15.8444 5.14668C15.8564 5.09681 15.8675 4.91089 15.7544 4.81273C15.6414 4.71456 15.4745 4.74813 15.3541 4.77483C15.1834 4.81267 12.4646 6.56807 7.19761 10.041C6.42588 10.5587 5.72687 10.8109 5.10058 10.7977C4.41015 10.7831 3.08204 10.4163 2.09473 10.1028C0.883743 9.7183 -0.0787216 9.51501 0.00508745 8.86197C0.0487404 8.52183 0.528258 8.17397 1.44364 7.81839Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0518650e9e12829bfcdc4f7782e272aa.svg";
export { ForwardRef as ReactComponent };